var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"patientDetail"},[_c('PatientDetail',{attrs:{"backRoute":"DoctorPatientsList"},on:{"viewPatientFiles":_vm.viewPatientFiles}}),_c('PatientTreatmentList',{attrs:{"treatmentHistoryDetailRoute":"DoctorPatientTreatmentDetail"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }